import { Alert, AlertTitle, SxProps } from '@mui/material';

type Props = {
  title?: string;
  text?: string;
  showAlert: boolean | string | undefined;
  sx?: SxProps;
};

const ErrorAlert = ({ title, text, showAlert, sx }: Props) => {
  return !!showAlert ? (
    <Alert severity="error" sx={sx}>
      <AlertTitle>{title}</AlertTitle>
      {text}
    </Alert>
  ) : (
    <></>
  );
};
export default ErrorAlert;
